<template>
    <v-navigation-drawer
            id="appDrawer"
            :mini-variant.sync="mini"
            fixed
            :dark="$vuetify.dark"
            app
            v-model="drawer"
            width="260"
            mobile-break-point="1130"
    >
        <v-toolbar class="elevation-0" color="primary darken-1" dark>
            <!--<img v-bind:src="computeLogo" height="36" alt="Vue Material Admin Template">-->
            <!--<v-toolbar-title class="ml-0 pl-3">-->
                <!--<span class="hidden-sm-and-down">{{ $t('app.name') }}</span>-->
            <!--</v-toolbar-title>-->
        </v-toolbar>
        <vue-perfect-scrollbar class="drawer-menu--scroll" :settings="scrollSettings">
            <v-list dense expand>
                <template v-for="(item, i) in menus">
                    <!--group with subitems-->
                    <v-list-group v-if="item.items" v-show="hasChildItem(item)" :key="item.name" :value="expand(item)">
                        <v-list-tile slot="activator" ripple="ripple">
                            <v-list-tile-action>
                                <v-icon>{{item.icon}} fa-fw</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>{{ $t(item.title) }}</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                        <template v-for="(subItem, i) in item.items">
                            <!--sub group-->
                            <!--<v-list-group v-if="subItem.items" :key="subItem.name" :group="subItem.group" sub-group="sub-group">-->
                                <!--<v-list-tile slot="activator" ripple="ripple">-->
                                    <!--<v-list-tile-content>-->
                                        <!--<v-list-tile-title>{{ subItem.title }}</v-list-tile-title>-->
                                    <!--</v-list-tile-content>-->
                                <!--</v-list-tile>-->
                                <!--<v-list-tile v-for="(grand, i) in subItem.children" :key="i" :to="genChildTarget(item, grand)" :href="grand.href" ripple="ripple">-->
                                    <!--<v-list-tile-content>-->
                                        <!--<v-list-tile-title>{{ grand.title }}</v-list-tile-title>-->
                                    <!--</v-list-tile-content>-->
                                <!--</v-list-tile>-->
                            <!--</v-list-group>-->
                            <!--child item-->
                            <v-list-tile v-if="hasPermission(subItem)" :key="i" :to="getUrl(subItem.name)" :href="getUrl(subItem.name)" :disabled="subItem.disabled" ripple="ripple">
                                <v-list-tile-action>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                    <v-list-tile-title><span>{{ $t(subItem.title)}}</span></v-list-tile-title>
                                </v-list-tile-content>
                                <!-- <v-circle class="white--text pa-0 circle-pill" v-if="subItem.badge" color="red" disabled="disabled">{{ subItem.badge }}</v-circle> -->
                                <!--<v-list-tile-action v-if="subItem.action">-->
                                    <!--<v-icon :class="[subItem.actionClass || 'success&#45;&#45;text']">{{ subItem.action }}</v-icon>-->
                                <!--</v-list-tile-action>-->
                            </v-list-tile>
                        </template>
                    </v-list-group>
                    <v-subheader v-else-if="item.header" :key="i">{{ item.header }}</v-subheader>
                    <v-divider v-else-if="item.divider" :key="i"></v-divider>
                    <!--top-level link-->
                    <v-list-tile v-else-if="hasPermission(item)" :to="getUrl(item.name)" :href="getUrl(item.name)" ripple="ripple" :disabled="item.disabled" :target="item.target" rel="noopener" :key="item.name">
                        <v-list-tile-action v-if="item.icon">
                            <v-icon>{{ item.icon }} fa-fw</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                        </v-list-tile-content>
                        <!-- <v-circle class="white--text pa-0 chip--x-small" v-if="item.badge" :color="item.color || 'primary'" disabled="disabled">{{ item.badge }}</v-circle> -->
                        <v-list-tile-action v-if="item.subAction">
                            <v-icon class="success--text">{{ item.subAction }}</v-icon>
                        </v-list-tile-action>
                        <!-- <v-circle class="caption blue lighten-2 white--text mx-0" v-else-if="item.chip" label="label" small="small">{{ item.chip }}</v-circle> -->
                    </v-list-tile>
                </template>
            </v-list>
        </vue-perfect-scrollbar>
    </v-navigation-drawer>
</template>
<script>
    import {UrlServices} from "~/utils/url-manager";
    import VuePerfectScrollbar from 'vue-perfect-scrollbar';
    import AuthHelper from '~/utils/auth-helper';
    import menu from '~/menu'
    import { isMobile } from 'mobile-device-detect';
    export default {
        name: 'app-drawer',
        components: {
            VuePerfectScrollbar,
        },
        props: {
            expanded: {
                type: Boolean,
                default: true
            },
        },
        data: () => ({
            mini: false,
            drawer: !isMobile,
            menus: menu,
            scrollSettings: {
                maxScrollbarLength: 160
            }
        }),
        computed: {
            computeGroupActive () {
                return true;
            },
            computeLogo () {
                return '/static/m.png';
            },
            sideToolbarColor () {
                return this.$vuetify.options.extra.sideNav;
            },
        },
        created () {
            window.getApp.$on('APP_DRAWER_TOGGLED', () => {
                this.drawer = (!this.drawer);
            });
        },
        mounted() {

        },
        methods: {
            getRouteObject(route_name){
                return UrlServices.getRouteObject({
                    name: route_name
                });
            },
            getUrl(route_name) {
                let routeObject = this.getRouteObject(route_name);
                return UrlServices.rewriteUrl(routeObject.href);
            },
            hasChildItem(item) {
                let me = this;
                let childs = item.items;
                // Use _.any instead of _.each for better performance
                return _.some(childs, (child_item) => {
                    return me.hasPermission(child_item);
                });
            },
            hasPermission(item) {
                if(this.getRouteObject(item.name).resolved.meta.required_permissions){
                    return AuthHelper.hasPermission(this.getRouteObject(item.name).resolved.meta.required_permissions);
                }
                return true;
            },
            expand(item) {
                return _.some(item.items, x => {
                    return x.name === this.$route.name;
                });
            }
        }
    };
</script>


<style lang="stylus">
    #appDrawer{
        overflow: hidden;
    }
    .drawer-menu--scroll{
        height: calc(100vh - 48px);
        overflow: auto;
    }
</style>